import type {DeliveryInterval} from 'src/shared/types'

import {convertToStandardDate} from './convert-to-standard-date'

export const withCorrectDeliveryDate = (deliveryIntervals: DeliveryInterval[], date?: string) => {
  if (deliveryIntervals.length === 0) {
    return undefined
  }

  if (date) {
    return date
  }

  const [firstInterval] = deliveryIntervals

  return firstInterval?.from ? convertToStandardDate(firstInterval.from) : undefined
}
